export default __webpack_public_path__ + "static/media/jcb.04ce6515.svg";